import { ReactNode } from 'react'

import { Checkbox } from '../../../Checkbox'
import { CheckPickerItemType, CheckPickerOnSelect } from '../../CheckPicker.types'

interface OptionCheckboxProps<OptionType extends string> {
  label: ReactNode
  option: CheckPickerItemType<OptionType>
  value?: OptionType[]
  onSelect?: CheckPickerOnSelect<OptionType>
}

export const OptionCheckbox = <OptionType extends string>({
  label,
  option,
  value,
  onSelect,
}: OptionCheckboxProps<OptionType>) => (
  <Checkbox.Regular
    id={option.value}
    dot={option.dot}
    subtitle={option.subtitle}
    value={label?.toString()}
    title={label}
    checked={value?.includes(option.value)}
    onChange={event => {
      if (!onSelect) {
        return
      }
      const selection = value?.find(selectedValue => selectedValue === option.value)
        ? value.filter(selectedValue => selectedValue !== option.value)
        : [...(value || []), option.value]
      onSelect(selection, option, event)
    }}
    hasFullWidth
  />
)
